// checkHasActiveFilters — derive whether any restaurant filter is active.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (the module-level
// `checkHasActiveFilters` helper) as part of the behavior-preserving refactor
// (issue #240). The boolean expression — `filters.cuisine`, `filters.priceRange`,
// or `filters.minRating > 0`, coerced with `!!(...)` — is copied exactly,
// including operand order.
//
// Totality mirrors the source EXACTLY:
//   The source read `filters.cuisine`, `filters.priceRange`, and
//   `filters.minRating` directly without guarding `filters`. No extra guard is
//   added; a missing `filters` throws here exactly as it would in the source.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Determine whether any filter has a non-default value.
 *
 * @param {Object} filters - The active filter values ({ cuisine, priceRange, minRating }).
 * @returns {boolean} True when cuisine, priceRange, or a positive minRating is set.
 */
function checkHasActiveFilters(filters) {
  return !!(filters.cuisine || filters.priceRange || filters.minRating > 0);
}

export { checkHasActiveFilters };
export default checkHasActiveFilters;
